import React from "react";
import { Toast, ToastBody, ToastHeader } from "reactstrap";

const MotivationalToast = ({ isOpen, message, isMotivational }) => {
  return (
    <>
      {/* Include keyframes here */}
      <style>
        {`
          @keyframes slideInRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0%);
              opacity: 1;
            }
          }
        `}
      </style>

      <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 1050,
          animation: isOpen ? "slideInRight 0.5s ease-out" : "none",
        }}
      >
        <Toast
          isOpen={isOpen}
          style={{
            minWidth: "300px",
            borderRadius: "12px",
            background: "linear-gradient(135deg, #D2FFFDFF 0%, #9FC4FCFF 100%)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            color: "#333",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          }}
        >
          <ToastHeader
            style={{
              fontWeight: "700",
              fontSize: "1.1rem",
              backgroundColor: "transparent",
              borderBottom: "none",
              whiteSpace: "nowrap",
            }}
          >
            {isMotivational? `🚀 Keep Pushing, You're Crushing It!`: 'Discount offer'}
          </ToastHeader>
          <ToastBody style={{ fontSize: "1rem" }}>{message}</ToastBody>
        </Toast>
      </div>
    </>
  );
};

export default MotivationalToast;
